import React from 'react';
import PropTypes from 'prop-types';
import { ThemeContext } from 'styled-components';
import Follow from './follow';
import { SectionTitle } from '../../../shared/sectionable/styles';

export default function Title({ fund }) {
  const { isMobile } = React.useContext(ThemeContext);

  return (
    <SectionTitle>
      updates
      {!isMobile && <Follow fund={fund} />}
    </SectionTitle>
  );
}

Title.propTypes = {
  fund: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    isFollowedByCurrentUser: PropTypes.bool.isRequired,
  }).isRequired,
};
